module.exports = __webpack_public_path__ + "static/media/ImgPDF2.7ba57ff0.svg";